if (!customElements.get('info-tabs-accordion')) {
  customElements.define(
    'info-tabs-accordion',
    class InfoTabsAccordion extends HTMLElement {
      // Below 768px the PDP info tabs are shown as accordions instead. Each tab
      // panel's content nodes are moved (not cloned, so images aren't fetched
      // twice) into the matching accordion, and moved back above 768px.
      // pdp-layout.js may move this element on mobile, which re-runs
      // connectedCallback -- the listener is removed on disconnect and sync()
      // is safe to re-run.
      connectedCallback() {
        this.mql = window.matchMedia('(max-width: 767.98px)');
        this.sync = this.sync.bind(this);
        this.mql.addEventListener('change', this.sync);
        this.sync();
      }

      disconnectedCallback() {
        this.mql.removeEventListener('change', this.sync);
      }

      sync() {
        this.querySelectorAll('[data-tab-panel]').forEach((accordionContent) => {
          const panel = this.querySelector(`#${accordionContent.dataset.tabPanel}`);
          if (!panel) return;

          const [from, to] = this.mql.matches ? [panel, accordionContent] : [accordionContent, panel];
          to.append(...from.childNodes);
        });
      }
    }
  );
}
